import React from "react"

export default function FormatPixel ({text}){
    

    return text.split('').map((letter,index) =>{
        if(index % 3 === 0){
            return <span key={index} className='pixel'>{letter}</span>
        }
        return letter
    }) 
}